import {ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import {AuthenticationService} from '../../../authentication.service';
import {GlobalService} from '../../../global.service';
import {EventsService} from '../../events/events.service';
import {SeasonsService} from '../seasons.service';
import {MatDialog, MatTabChangeEvent} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {UsersService} from '../../users/users.service';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {RaceDetailModalComponent} from '../../events/race-detail-modal/race-detail-modal.component';

@Component({
  selector: 'elastic-seasons-archive',
  templateUrl: './seasons-archive.component.html',
  styleUrls: ['./seasons-archive.component.scss']
})
export class SeasonsArchiveComponent implements OnInit, OnDestroy {


  seasons = [];

  selectedSubTab = 0;
  selectedTab = 0;
  sessionDate = '';
  activeSeason = "Season 1";

  archive = [];

  activeArchive = 0;

  event = {};

  language = navigator.language.includes('de') ? 'german' : 'english';

  desktopGap = '24px';
  mobileGap = '16px';

  timer: any;
  timer2: any;

  desktopWidth = `0 0 calc(33.3333% - ${this.desktopGap}`;
  tabletWidth = `0 0 calc(33.3333% - ${this.desktopGap}`;
  smallTabletWidth = `0 0 calc(50% - ${this.mobileGap}`;
  mobileWidth = `0 0 calc(100% - ${this.mobileGap}`;

  constructor( private _eventsService: EventsService,
               private _ngZone: NgZone,
               private cdr: ChangeDetectorRef,
               private auth: AuthenticationService,
               private seasonsService: SeasonsService,
               private globalService: GlobalService,
               private eventsService: EventsService,
               private dialog: MatDialog,
               private router: Router,
               private route: ActivatedRoute,
               private usersService: UsersService) { }

  ngOnInit() {





    this.getData();



    if (this.route.snapshot.queryParams['tab1']) {
      this.selectedTab = this.route.snapshot.queryParams['tab1'];
    }

    if (this.route.snapshot.queryParams['tab2']) {
      this.selectedSubTab = this.route.snapshot.queryParams['tab2'];
    }

  }

  changeEvent() {

  }


  getData() {

    this.seasonsService.getFinishedSeasons().subscribe( (data: any) => {
      if (data) {
        this.seasons = data;
        this.cdr.detectChanges();
      }
    });



  }

  getSeason(season_id) {
    this.seasonsService.getSeasonArchive(season_id).subscribe(
      ( response: HttpEvent<any> ) => {
        switch (response.type) {
          case HttpEventType.Response:

            this.archive = response.body;

            this.cdr.detectChanges();
            break;
        }
      });
  }

  openRaceModal(event, race) {

    this.dialog.open(RaceDetailModalComponent, {
      disableClose: false, data: {event_id: event, race_id: race}, minWidth: window.innerWidth - 400, maxWidth: window.innerWidth - 400
    }).afterClosed().subscribe(result => {

    });
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {

    this.selectedTab = tabChangeEvent.index;
    this.selectedSubTab = 0;

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        tab1: this.selectedTab
      },
      queryParamsHandling: 'merge',
      // preserve the existing query params in the route
      skipLocationChange: false
      // do not trigger navigation
    });

    //this.getData();

  }

  subTabChanged(tabChangeEvent: MatTabChangeEvent): void {

    this.selectedSubTab = tabChangeEvent.index;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        tab2: this.selectedSubTab
      },
      queryParamsHandling: 'merge',
      // preserve the existing query params in the route
      skipLocationChange: false
      // do not trigger navigation
    });

  }


  ngOnDestroy(): void {

  }

}
